


















































































































































































































































































































































































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { PaginationModel, VHeaders } from '@/models/pagedlistmodel';
import { Base } from '@/components/common/base';
import { availabilityService, shiftService, userService, callHistoryService } from '@/shared';
import { IDialogOption } from '@/models/dialog';
import { Search, WorkingShift } from '@/Alynk.dtos';
import { mapGetters } from 'vuex';
import { Utils } from '@/helper/utils';

import {
    HubConnection,
    HubConnectionBuilder,
    LogLevel,
} from '@microsoft/signalr';
import { AudioStreamList, TranscriptionList } from '@/models/telephony/audioStream';

@Component({
    computed: {
        ...mapGetters({ currentStoreId: 'getStoreId' }),
        liveCallRating: {
            get() {
                if (this.rating) {
                    const score = this.rating;
                    if (score == 0) {
                        return 'Very Poor';
                    } else if (score == 0.5) {
                        return 'Very Poor';
                    } else if (score == 1) {
                        return 'Poor';
                    } else if (score == 1.5) {
                        return 'Poor';
                    } else if (score == 2) {
                        return 'Average';
                    } else if (score == 2.5) {
                        return 'Average';
                    } else if (score == 3) {
                        return 'Average';
                    } else if (score == 3.5) {
                        return 'Good';
                    } else if (score == 4) {
                        return 'Good';
                    } else if (score == 4.5) {
                        return 'Excellent';
                    } else if (score == 5) {
                        return 'Excellent';
                    } else {
                        return 'N/A';
                    }
                }
            },
            set(val) {
                // computed
            },
        }
    },
    components: {
        Grid: () => import('@/components/common/app.grid.vue'),
        AppDialog: () => import('@/components/common/app.dialog.vue'),
    },
    props: ['dialog'],
})

export default class ServiceManagerDashboardPage extends Base {
    get trigger(): boolean {
        return this.$props.dialog;
    }
    set trigger(val) {
        this.$emit('closedialog', val);
    }
    public firstPanel: any = [0];
    public loading: boolean = false;
    public availabilityStatusLoading: boolean = false;
    public loadingShift: boolean = false;
    public pagination = new PaginationModel('userId', true, 5);
    public childPagination = new PaginationModel('Id', true, 5);
    public dialog: boolean;
    public storeId: number = 0;
    public tenantId: number = 0;
    public enterpriseId: number = 0;
    public actions: any[] = [];
    public items: any = [];
    public userId: string = '';
    public currentAvailabilityStatus: string = '';
    public availabilityStatus: string = '';
    public availabilityStatusItems: any[] = [];
    public storeShifts: any[] = [];
    public itemWorkShift: any[] = [];
    public startDay: string = '';
    public endDay: string = '';
    public existingShiftDays: number[] = [];
    public currentShiftDays: number[] = [];
    public workShiftActions: any[] = [];
    public workShiftHeaders: VHeaders[] = [];
    public panel: number = 0;
    public currentStoreId: number;
    public TotalCallsOfServicePhone: string = '';
    public TotalCallsOfMainPhone: string = '';
    public TotalCallsOfAdvisorWorkPhone: string = '';
    public TotalCallsOfAdvisorOpenRoRollOver: string = '';

    public TotalAppointmentScheduled: number = 0;
    public TotalAppointmentRescheduled: number = 0;
    public TotalAppointmentCancelled: number = 0;

    public selectWorkShiftId: number = null;
    public streamingText: string = '';
    public playRecording: boolean = false;
    public isPlaying: boolean = false;
    public rating: number = 0;
    public streamId: string = '';
    public connection: HubConnection;
    public inboundChunkIsPlaying: boolean;

    public isOutboundChunkIsPlaying: boolean;

    public searchOnDms: boolean = false;
    public activeCalls: any[] = [];
    public src: string = '';

    public selectedStore: string = '';
    public audioList: AudioStreamList[] = [];
    public transcriptionList: TranscriptionList[] = [];

    public arrayOfTranscription = [];
    public sentimentText: string;
    public callSid: string = '';

    public itemDays: any[] = [
        { id: "1", text: "Monday" },
        { id: "2", text: "Tuesday" },
        { id: "3", text: "Wednesday" },
        { id: "4", text: "Thursday" },
        { id: "5", text: "Friday" },
        { id: "6", text: "Saturday" },
        { id: "7", text: "Sunday" },
    ];

    public currentCallData = {
        tenantId: undefined,
        enterpriseId: undefined,
        storeId: undefined,
        streamId: undefined,
        sentiments: undefined,
        fromNumber: undefined,
        toNumber: undefined,
        createdAt: undefined,
        customerName: undefined,
        dealerShipName: undefined
    };
    public headers: VHeaders[] = [
        {
            text: 'First Name',
            align: 'left',
            sortable: true,
            value: 'firstName',
        },
        {
            text: 'Last Name',
            align: 'left',
            sortable: true,
            value: 'lastName',
        },
        // {
        //     text: 'Email',
        //     align: 'left',
        //     sortable: true,
        //     value: 'email',
        // },
        {
            text: 'Work Phone',
            align: 'left',
            sortable: true,
            value: 'workPhone',
        },
        {
            text: 'Calls Today',
            sortable: true,
            align: 'left',
            value: 'totalWorkCalls',
            fieldType: 'template',
            template: (item) => {
                if (item.totalWorkCalls == "")
                    return `<span class= "px-1"> 0 </span>`;
                else
                    return `<span class= "px-1"> ${item.totalWorkCalls} </span>`;
            }
        },
        {
            text: 'Rollover Call Count',
            sortable: true,
            align: 'left',
            value: 'totalRoCalls',
            fieldType: 'template',
            template: (item) => {
                if (item.totalRoCalls == "")
                    return `<span class= "px-1"> 0 </span>`;
                else
                    return `<span class= "px-1"> ${item.totalRoCalls} </span>`;
            }
        },
        {
            text: "Status",
            align: 'left',
            sortable: true,
            value: 'availabilityStatus',
            fieldType: 'template',
            template: (item) => {
                if (item.availabilityStatus == "Available")
                    return `<span class= "px-1" style="color:green"> ${item.availabilityStatus} </span>`;
                else
                    return `<span class= "px-1" style="color:red"> ${item.availabilityStatus} </span>`;
            }
        },
        {
            align: 'center',
            isNotDataProp: true,
            text: "Actions",
            sortable: false,
        },
    ];

    public mounted() {
        this.$root.$emit('sidebar.layout.vue', 'CallManagerTextDashboard');
        this.storeId = this.currentStoreId;
        this.getServiceManagersList();
        this.setActions();
        this.getShifts();
        this.setWorkShiftHeaders();
        this.setWorkShiftActions();
        this.getAllLiveCall();
        this.getScheduledAppointmentCount();

        //Live Call Code
        window.AudioContext = window.AudioContext; // || window.webkitAudioContext || window.mozAudioContext;

        this.connection = new HubConnectionBuilder()
            .withUrl(Utils.API_WEB_HUB_URL)
            .configureLogging(LogLevel.Information)
            .build();

        this.connection.serverTimeoutInMilliseconds = 100000;

        const vm = this;

        this.connection.on('LiveCallListNotification', function (message) {
            console.log("Call comes");
            vm.getUpdatedLiveCall(message);
        });
        this.connection.on('LiveSentiments_' + this.currentStoreId, function (message) {
            const liveCall = vm.activeCalls.filter(
                (x) => x.streamId == message.streamId
            )[0];
            if (liveCall) {
                vm.activeCalls = vm.activeCalls.filter(
                    (x) => x.streamId != message.streamId
                );
                liveCall.sentiments = message.sentiments;
                vm.activeCalls.push(liveCall);
                // vm.pagination.totalItems = vm.activeCalls.length;
                if (vm.streamId == message.streamId) {
                    vm.GetCustomerSentiment(vm, parseFloat(liveCall.sentiments));
                }
            }
        });

        this.connection.on('RemoveCall', function (message) {

            vm.removeLiveCall(message);
        });

        this.connection
            .start()
            .then(function () {
                console.log('Connected!');
            })
            .catch(function (err) {
                console.log('SignalR Connection Error: ', err);
            });

        this.connection.onclose(() => {
            console.log('Connection disconnected');
            setTimeout(startSignalRConnection(this.connection), 1000);
        });

        const startSignalRConnection = (connection) =>
            connection
                .start()
                .then(() => console.info('Websocket Connection ReEstablished'))
                .catch(function (err) {
                    console.log('SignalR Connection Error: ', err);
                });
    }

    public setWorkShiftActions() {
        this.workShiftActions = [
            {
                type: 'button',
                icon: 'fas fa-trash-alt',
                title: 'Delete',
                color: 'error',
                action: (model: any) => {
                    this.deleteWorkShift(model);
                },
            },
        ];
    }

    public setWorkShiftHeaders() {
        this.workShiftHeaders = [
            {
                text: 'Start Day',
                align: 'left',
                value: 'startDay',
                sortable: false,
                fieldType: 'template',
                template: (item) => {
                    if (item.startDay != "") {
                        return `<div style='display:flex;justify-content:center'><span>${this.GetWeekNameFromList(item.startDay)}</span></div>`;
                    }
                }
            },
            {
                text: 'End Day',
                align: 'left',
                value: 'endDay',
                sortable: false,
                fieldType: 'template',
                template: (item) => {
                    if (item.endDay != "") {
                        return `<div style='display:flex;justify-content:center'><span>${this.GetWeekNameFromList(item.endDay)}</span></div>`;
                    }
                }
            },
            {
                align: 'left',
                sortable: true,
                text: "Shift",
                value: 'shiftName',
            },
            {
                align: 'center',
                isNotDataProp: true,
                text: 'Action',
                sortable: false,
            }
        ];
    }

    public changeAvailabilityDialog: IDialogOption = {
        width: 500,
        title: 'Change Availability Status',
        model: false,
        loading: false,
        action: {
            color: 'success',
            icon: 'fas fa-check',
            text: 'Change Status',
            disable: false,
        },
        onAction: (): void => {

            this.confirmServiceManagerAvailabilityStatus();
        }
    };

    public confirmAvailabilityStatusDialog: IDialogOption = {
        width: 350,
        title: "Confirm?",
        model: false,
        loading: false,
        action: {
            color: 'success',
            icon: 'fas fa-check',
            text: "Update",
        },
        onAction: (): void => {
            this.UpdateServiceManagerAvailabilityStatus();
        }
    };

    public updateShiftDialog: IDialogOption = {
        width: 750,
        title: 'Modify Work Shift',
        model: false,
        loading: false,
        action: {
            color: 'success',
            icon: 'fas fa-check',
            text: 'Modify Work Shift',
            disable: false,
        },
        onAction: (): void => {
            this.ConfirmAddServiceManagerShift();
        },
        onClose: (): void => {
            this.updateShiftDialog.model = false;
        }
    };

    public confirmAddWorkShiftDialog: IDialogOption = {
        width: 350,
        title: "Confirm?",
        model: false,
        loading: false,
        action: {
            color: 'success',
            icon: 'fas fa-check',
            text: "Modify",
        },
        onAction: (): void => {
            this.UpdateServiceManagerShift();
        }
    };


    public setActions() {
        this.actions = [
            {
                type: 'button',
                icon: 'fa fa-play-circle',
                title: 'Play Call',
                action: (model: any) => {
                    this.showPopup(model);
                },
                visible: (model) => {
                    return model.activeCallData;
                },
            },
            {
                type: 'button',
                icon: 'fas fa-file-alt',
                title: "Update Status",
                action: (model: any) => {
                    this.changeAvailabilityDialog.model = true;
                    this.userId = model.userId;
                    this.currentAvailabilityStatus = model.availabilityStatus;
                    this.availabilityStatus = model.availabilityStatus;
                    this.getStatus();
                },
            },
            {
                type: 'button',
                icon: 'fa-clock-o',
                title: "Modify Work Shift",
                action: (model: any) => {
                    this.SetValueToWorkShiftGridItems(model);
                },
            },
        ];
    }


    public showPopup(model) {

        this.playRecording = true;
        this.isPlaying = false;
        this.streamingText = '';
        this.rating = 0;
        this.streamId = model.activeCallData.streamId;
        const vm = this;
        this.GetCustomerSentiment(vm, parseFloat(model.activeCallData.sentiments || '0'));
    }
    public GetCustomerSentiment(vm, sentimentScore) {
        console.log('Rating ', sentimentScore);
        const score = sentimentScore * 10;
        switch (true) {
            case score <= -9:
                vm.rating = 0;
                break;
            case score <= -8 && score <= -7:
                vm.rating = 0.5;
                break;
            case score <= -6 && score <= -5:
                vm.rating = 1;
                break;
            case score <= -4 && score <= -3:
                vm.rating = 1.5;
                break;
            case score <= -2 && score <= -1:
                vm.rating = 2;
                break;
            case score <= 0 && score <= 1:
                vm.rating = 2.5;
                break;
            case score <= 2 && score <= 3:
                vm.rating = 3;
                break;
            case score <= 4 && score <= 5:
                vm.rating = 3.5;
                break;
            case score <= 6 && score <= 7:
                vm.rating = 4;
                break;
            case score <= 8 && score <= 9:
                vm.rating = 4.5;
                break;
            case score <= 10:
                vm.rating = 5;
                break;
        }
    }



    public async getStatus(): Promise<void> {
        try {
            this.availabilityStatusLoading = true;
            const statusList = await availabilityService.getAvailabilityStatus();
            this.availabilityStatusItems = statusList;
        } finally {
            this.availabilityStatusLoading = false;
        }
    }

    public SetValueToWorkShiftGridItems(model: any) {
        this.loadingShift = true;
        this.updateShiftDialog.model = true;
        this.userId = model.userId;
        this.itemWorkShift = [];
        model.workingShift?.forEach(element => {
            this.itemWorkShift.push(element);
        });
        this.loadingShift = false;
    }

    public async confirmServiceManagerAvailabilityStatus(): Promise<void> {
        if (!(await this.validateFormByScope('Status'))) {
            return;
        }
        if (this.currentAvailabilityStatus == this.availabilityStatus) {
            this.showAlert(false, 'User already set with same status');
            return;
        }
        this.confirmAvailabilityStatusDialog.model = true;
    }


    public async UpdateServiceManagerAvailabilityStatus(): Promise<void> {

        try {
            this.changeAvailabilityDialog.model = true;
            this.changeAvailabilityDialog.loading = true;
            this.confirmAvailabilityStatusDialog.loading = true;
            await userService.updateServiceManagerAvailabilityStatus(this.userId, this.storeId, this.availabilityStatus);
            this.showAlert(true, 'User availability status updated successfully');
        } finally {
            this.changeAvailabilityDialog.model = false;
            this.changeAvailabilityDialog.loading = false;
            this.confirmAvailabilityStatusDialog.model = false;
            this.confirmAvailabilityStatusDialog.loading = false;
            this.userId = '';
            this.availabilityStatus = '';
            this.currentAvailabilityStatus = '';
            this.getServiceManagersList();
            this.setActions();
        }
    }



    public async ConfirmAddServiceManagerShift(): Promise<void> {
        this.confirmAddWorkShiftDialog.model = true;
        // if (this.itemWorkShift.length > 0) {
        //     this.confirmAddWorkShiftDialog.model = true;
        // } else {
        //     this.showAlert(false, 'No data found');
        //     return;
        // }
    }


    public async UpdateServiceManagerShift(): Promise<void> {
        // if (this.itemWorkShift.length > 0) {

        try {
            this.updateShiftDialog.model = true;
            this.updateShiftDialog.loading = true;
            this.confirmAddWorkShiftDialog.model = true;
            this.confirmAddWorkShiftDialog.loading = true;
            await userService.updateServiceManagerShift(this.userId, this.storeId, this.itemWorkShift);
            this.showAlert(true, 'Work Shift modified successfully');
        } finally {
            this.updateShiftDialog.model = false;
            this.updateShiftDialog.loading = false;
            this.confirmAddWorkShiftDialog.model = false;
            this.confirmAddWorkShiftDialog.loading = false;
            this.userId = '';
            this.availabilityStatus = '';
            this.currentAvailabilityStatus = '';
            this.itemWorkShift = [];
            this.getServiceManagersList();
            this.setActions();
        }
        // } else {
        //     this.showAlert(false, 'No data found');
        //     return;
        // }
    }



    public async getServiceManagersList(): Promise<void> {
        try {
            this.loading = true;
            const response = await userService.getServiceManagersList();
            this.items = response.userStoreProfile;
            this.TotalCallsOfServicePhone = response.totalCallsOfServicePhone != "" ? response.totalCallsOfServicePhone : "0";
            this.TotalCallsOfMainPhone = response.totalCallsOfMainPhone != "" ? response.totalCallsOfMainPhone : "0";
            this.TotalCallsOfAdvisorWorkPhone = response.totalCallsOfAdvisorWorkPhone != "" ? response.totalCallsOfAdvisorWorkPhone : "0";
            this.TotalCallsOfAdvisorOpenRoRollOver = response.totalCallsOfAdvisorOpenRoRollOver != "" ? response.totalCallsOfAdvisorOpenRoRollOver : "0";
            this.pagination.page = 1;
        } finally {
            this.loading = false;
        }
    }

    public async getShifts(): Promise<void> {
        try {
            this.loadingShift = true;
            const storeShifts = await shiftService.getStoreShifts(this.storeId);
            this.storeShifts = storeShifts;
        } finally {
            this.loadingShift = false;
        }
    }


    public async addWorkShift(): Promise<void> {
        if (!(await this.validateFormByScope('shiftData'))) {
            return;
        }
        if (this.selectWorkShiftId == 0) {
            this.showAlert(false, "Please select a valid shift");
            return;
        }
        let isShiftExist = this.checkWeekDaysExist();
        if (!isShiftExist) {
            let currentShift = this.storeShifts.find(x => x.value == this.selectWorkShiftId);
            let workShift = {
                shiftId: this.selectWorkShiftId,
                startDay: this.startDay,
                endDay: this.endDay,
                shiftName: currentShift.text
            };
            this.itemWorkShift.push(workShift);
            this.startDay = '';
            this.endDay = '';
            this.selectWorkShiftId = null;
        }
        else {
            this.showAlert(false, "This work shift day already exist.");
        }
    }


    public addDaysOfWeek(shiftStartDay: number, shiftEndDay: number, shiftDays: number[]): number[] {
        // Handle normal range (e.g., Wednesday to Friday)
        if (shiftStartDay <= shiftEndDay) {
            for (let dayOfWeek = shiftStartDay; dayOfWeek <= shiftEndDay; dayOfWeek++) {
                if (!shiftDays.includes(dayOfWeek)) {
                    shiftDays.push(dayOfWeek);
                }
            }
        }

        // Handle wrap-around range (e.g., Saturday to Tuesday)
        if (shiftStartDay > shiftEndDay) {
            // Add days from start day to end of week
            for (let dayOfWeek = shiftStartDay; dayOfWeek <= 7; dayOfWeek++) {
                if (!shiftDays.includes(dayOfWeek)) {
                    shiftDays.push(dayOfWeek);
                }
            }

            // Add days from start of week to end day
            for (let dayOfWeek = 1; dayOfWeek <= shiftEndDay; dayOfWeek++) {
                if (!shiftDays.includes(dayOfWeek)) {
                    shiftDays.push(dayOfWeek);
                }
            }
        }

        return shiftDays;
    }

    public checkWeekDaysExist() {
        if (this.itemWorkShift.length == 0) {
            return false;
        }
        this.itemWorkShift.forEach((shift: any) => {
            this.addDaysOfWeek(Number(shift.startDay), Number(shift.endDay), this.existingShiftDays);
        });
        this.addDaysOfWeek(Number(this.startDay), Number(this.endDay), this.currentShiftDays);
        // Check if any of the current shift days overlap with existing shift days
        if (this.currentShiftDays.some(currentShiftDay => this.existingShiftDays.includes(currentShiftDay))) {
            this.existingShiftDays = [];
            this.currentShiftDays = [];
            return true;
        }
        this.existingShiftDays = [];
        this.currentShiftDays = [];
        return false;
    }

    public GetWeekNameFromList(weekDayId) {
        let weekDayName = this.itemDays.find(x => x.id == weekDayId);
        return weekDayName.text;
    }

    public deleteWorkShift(item) {
        this.loadingShift = true;
        const index = this.itemWorkShift.indexOf(item);
        if (index > -1) {
            this.itemWorkShift.splice(index, 1);
        }
        this.loadingShift = false;
    }

    public updatePaging(paging: any) {
        this.pagination = paging;
    }

    public updateChildPaging(paging: any) {
        this.childPagination = paging;
    }

    public async getAllLiveCall(): Promise<void> {

        try {
            this.loading = true;
            this.$emit('update:progress', this.loading);
            const response = await callHistoryService.getAllLiveCalls();
            for (let index = 0; index < response.length; index++) {
                const element = response[index];
                this.getUpdatedLiveCall(element);
            }
        } finally {
            this.loading = false;
            this.$emit('update:progress', this.loading);
        }
    }

    public async getUpdatedLiveCall(data): Promise<void> {
        try {
            this.loading = true;
            this.$emit('update:progress', this.loading);
            // this.StreamText(this, data.callSid);
            this.GetCustomerSentiment(this, parseFloat(data.sentiments || '0'));
            // this.UpdateCustomerSentiment(this, data.callSid);
            this.LiveAudioStream(this, data.callSid);

            const liveCall = this.activeCalls.filter(
                (x) => x.streamId == data.streamId
            );
            if (liveCall.length == 0 && this.currentStoreId == data.storeId || true) {
                this.activeCalls.push({
                    tenantId: data.tenantId,
                    enterpriseId: data.enterpriseId,
                    storeId: data.storeId,
                    streamId: data.streamId,
                    sentiments: data.sentiments,
                    fromNumber: data.fromNumber,
                    toNumber: data.toNumber,
                    createdAt: data.createdAt,
                    customerName: data.customerName,
                    dealerShipName: data.dealerShipName,
                });
                if (this.items && this.items.length > 0) {
                    this.loading = true;
                    this.items.forEach(item => {
                        //if (item.workPhone == "+10000000002" || item.workPhone == data.toNumber || item.openRoRollOverNumber == data.toNumber 
                        if (item.workPhone == data.toNumber || item.openRoRollOverNumber == data.toNumber) {

                            this.currentCallData.tenantId = data.tenantId;
                            this.currentCallData.enterpriseId = data.enterpriseId;
                            this.currentCallData.storeId = data.storeId;
                            this.currentCallData.streamId = data.streamId;
                            this.currentCallData.sentiments = data.sentiments;
                            this.currentCallData.fromNumber = data.fromNumber;
                            this.currentCallData.toNumber = data.toNumber;
                            this.currentCallData.createdAt = data.createdAt;
                            this.currentCallData.customerName = data.customerName;
                            this.currentCallData.dealerShipName = data.dealerShipName;
                            item['activeCallData'] = this.currentCallData;
                        }
                    });
                    this.setActions();
                    this.loading = false;
                }

            }

        } finally {
            this.loading = false;
            this.$emit('update:progress', this.loading);
        }
    }
    public async removeLiveCall(data): Promise<void> {
        try {
            this.loading = true;
            if (this.streamId == data) {
                this.isPlaying = false;
                this.playRecording = false;
                this.stopRecording();
                this.sentimentText = '';
                this.searchOnDms = false;
            }
            this.$emit('update:progress', this.loading);

            const vm = this;
            this.audioList = vm.audioList.filter((x) => x.streamId != data);
            const liveCall = this.activeCalls.filter((x) => x.streamId != data);

            this.activeCalls = liveCall;

            if (this.items && this.items.length > 0) {
                this.loading = true;
                this.items.forEach(item => {
                    //if (item.workPhone == "+10000000002" || item.workPhone == data.toNumber || item.openRoRollOverNumber == data.toNumber 
                    if (item.workPhone == data.toNumber || item.openRoRollOverNumber == data.toNumber) {

                        delete item['activeCallData'];
                    }
                });
                this.setActions();
                this.loading = false;
            }



            // Get final text sentiment
            // var finalStream = vm.transcriptionList.filter((x) => x.streamId == data);
            // console.log("finalStream " + finalStream);

            // if (finalStream.length > 0) {
            //   var finalText = finalStream.map((x) => x.transcriptionText).join(" ");

            //   vm.connection.invoke(
            //     "getCustomerFinalSentiment",
            //     finalText,
            //     finalStream[0].streamId,
            //     vm.currentStoreId,
            //     finalStream[0].callSid
            //   );
            //   this.transcriptionList = vm.transcriptionList.filter(
            //     (x) => x.streamId != data
            //   );
            // }
        } finally {
            this.loading = false;
            this.$emit('update:progress', this.loading);
        }
    }

    public stopRecording() {
        this.audioList = this.audioList.filter((x) => x.streamId != this.streamId);
        this.src = '';
        this.streamId = '';
        this.playRecording = false;
        this.isPlaying = false;
        this.arrayOfTranscription = [];
        this.sentimentText = '';
    }
    public startTranscription(text, streamId, callDirection) {
        // if (this.streamId && this.streamId == streamId && this.isPlaying) {
        this.streamingText += '\n' + text;
        this.arrayOfTranscription.push({
            text,
            streamId,
            callDirection,
            receivedAt: new Date(),
        });
        if (this.arrayOfTranscription.length > 6) {
            this.arrayOfTranscription.shift();
        }
        // } else {
        //   this.arrayOfTranscription = [];
        //   this.streamingText = '';
        // }
    }

    public startAudio(bytes, streamId, track, text) {
        if (this.streamId == streamId) {
            this.audioList.push({
                streamId,
                audioStream: bytes,
                track,
                transcriptionText: text
            });
        }
    }
    public LiveAudioStream(vm, callSid) {
        this.connection.on('LiveAudioStream_' + callSid, function (message) {
            if (message.streamId == vm.streamId && message.transcriptionText != '') {
                console.error('message.transcriptionText ' + message.transcriptionText);
                vm.startTranscription(
                    message.transcriptionText,
                    message.streamId,
                    message.track
                );
            }
            vm.startAudio(
                message.audioStream,
                message.streamId,
                message.track,
                message.transcriptionText
            );
        });
    }

    public playLiveAudio() {
        this.isPlaying = !this.isPlaying;

        if (this.isPlaying) {
            const vm = this;
            let isStarted = false;
            setInterval((x) => {
                // tslint:disable: no-shadowed-variable
                if (
                    vm.audioList.filter(
                        (x) => x.streamId == vm.streamId && x.track == 'inbound'
                    ).length < 2
                ) {
                    return;
                }
                if (!isStarted) {
                    isStarted = true;
                    vm.liveOutBoundAudio();
                    vm.liveAudio();
                }
            }, 1000);
        }
    }

    public liveAudio() {
        if (this.isPlaying) {
            const vm = this;
            const chunkToPlay = vm.audioList.filter(
                (x) => x.streamId == vm.streamId && x.track == 'inbound'
            )[0];
            if (chunkToPlay && !vm.inboundChunkIsPlaying) {
                vm.inboundChunkIsPlaying = true;
                // if (chunkToPlay.transcriptionText)
                // {
                // console.log('chunkText:',chunkToPlay.transcriptionText);
                //   //Play Trancription
                //   vm.playLiveTranscription(
                //     chunkToPlay.transcriptionText,
                //     chunkToPlay.streamId,
                //     chunkToPlay.track
                //   );

                // }

                const context = new AudioContext();
                const source = context.createBufferSource();
                const blob = new Blob(
                    [new Uint8Array(JSON.parse('[' + chunkToPlay.audioStream + ']'))],
                    {
                        type: 'audio/wav',
                    }
                );
                blob.arrayBuffer().then((x) => {
                    context.decodeAudioData(
                        x,
                        function (buffer) {
                            source.buffer = buffer;
                        },
                        null
                    );

                    source.connect(context.destination);
                    source.onended = function () {
                        vm.audioList.splice(vm.audioList.indexOf(chunkToPlay), 1);
                        vm.inboundChunkIsPlaying = false;
                        vm.liveAudio();
                    };
                    // now play the sound.
                    source.start(0);
                });
            } else {
                setTimeout(() => {
                    vm.liveAudio();
                }, 500);
            }
        }
    }
    public liveOutBoundAudio() {
        if (this.isPlaying) {
            const vm = this;
            const chunkToPlay = vm.audioList.filter(
                (x) => x.streamId == vm.streamId && x.track == 'outbound'
            )[0];
            if (chunkToPlay && !vm.isOutboundChunkIsPlaying) {
                vm.isOutboundChunkIsPlaying = true;

                // if (chunkToPlay.transcriptionText)
                // {
                //   //Play Trancription
                //   vm.playLiveTranscription(
                //     chunkToPlay.transcriptionText,
                //     chunkToPlay.streamId,
                //     chunkToPlay.track
                //   );
                // }

                const context = new AudioContext();
                const source = context.createBufferSource();
                const blob = new Blob(
                    [new Uint8Array(JSON.parse('[' + chunkToPlay.audioStream + ']'))],
                    {
                        type: 'audio/wav',
                    }
                );
                blob.arrayBuffer().then((x) => {
                    context.decodeAudioData(
                        x,
                        function (buffer) {
                            source.buffer = buffer;
                        },
                        null
                    );

                    source.connect(context.destination);
                    source.onended = function () {
                        vm.audioList.splice(vm.audioList.indexOf(chunkToPlay), 1);
                        vm.isOutboundChunkIsPlaying = false;
                        vm.liveOutBoundAudio();
                    };
                    // now play the sound.
                    source.start(0);
                });
            } else {
                setTimeout(() => {
                    vm.liveOutBoundAudio();
                }, 500);
            }
        }
    }

    public async getScheduledAppointmentCount() {
        try {
            this.loading = true;
            const response = await userService.getScheduledAppointmentCount(this.storeId);
            this.TotalAppointmentScheduled = response.scheduledAppointmentCount;
            this.TotalAppointmentRescheduled = response.reScheduledAppointmentCount;
            this.TotalAppointmentCancelled = response.cancelledAppointmentCount;
        }
        finally {
            this.loading = false;
        }
    }
}
